<template>
  <div class="uploadButton">
    <p>ファイルを選択</p>
    <input type="file" @change="onFileChange" ref="file" @click="onClick" />
    <div v-if="selectedFile" class="selected-file-name">{{ selectedFile.name }}</div>
  </div>
</template>

<script lang="ts">
import _ from 'lodash'
import {
  Component, Prop, Vue,
} from 'vue-property-decorator'

@Component
export default class FileInput extends Vue {
  @Prop() value!: File;

  get selectedFile(): File|null {
    return this.value
  }

  set selectedFile(file: File|null) {
    this.$emit('input', file)
    this.$emit('changedFile')
  }

  private onClick(event: Event) {
    _.assign((event.target as HTMLInputElement), { value: '' })
    this.selectedFile = null
  }

  private onFileChange(event: Event) {
    const file = _.head((event.target as HTMLInputElement).files)
    this.selectedFile = file || null
  }
}

</script>

<style scoped>
.uploadButton {
  display:inline-block;
  position:relative;
  width:100%;
}

.uploadButton p {
  overflow:hidden;
  border: 1px solid #AAAFB6;
  border-radius: 30px;
  background:#fff;
  padding:5px;
  line-height:20px;
  cursor:pointer;
}

.uploadButton input[type=file] {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  cursor:pointer;
  opacity:0;
}
.selected-file-name {
  padding:3px;
  width:100%;
  margin-top:10px;
  margin-left:10px;
  border:none;
}
</style>
